<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>店铺名称：</label>
                <el-input v-model="search_Obj.f_title" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>状态：</label>
                <el-select v-model="search_Obj.f_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('goods_state')" :key="'goods_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="title" label="店铺名称" sortable="custom" width="240"></el-table-column>
                <el-table-column prop="address" label="地址" sortable="custom"></el-table-column>
                <el-table-column prop="state" label="状态" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.state, "goods_state") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_index" label="排序" sortable="custom" width="120"></el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看店铺"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'shopList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '店铺',
            menu_id: 7200,
            list_url: "/api/admin/shop/list",
            search_Obj: {
                f_title: '',
            },
            del_Obj:{
                url:'/api/admin/shop/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['goods_state'],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
        };
    },
    methods: {}
};
</script>